import { createSlice } from '@reduxjs/toolkit';
import { NO_CURRENT_ENTITY } from 'consts/store';
import { DATA_UNDEFINED, NO_ERRORS } from 'consts/xhr';
import {
  pendingActionHandler,
  readyActionHandler,
  rejectActionHandler,
} from 'helpers/sliceHelpers';
import {
  fetchOrderById,
  fetchAllOrders,
  create,
  createFinalized,
  accept,
  rectify,
  submit,
  cancel,
} from './orders.actions';
import adapter from './orders.adapter';
import { REDUCER_KEY } from './orders.consts';

const slice = createSlice({
  name: REDUCER_KEY,
  initialState: {
    ...adapter.getInitialState(),
    status: DATA_UNDEFINED,
    errors: NO_ERRORS,
    current: NO_CURRENT_ENTITY,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchAllOrders.fulfilled, (state, action) =>
        adapter.upsertMany(state, action.payload),
      )

      .addCase(fetchOrderById.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(create.fulfilled, (state, action) =>
        adapter.addOne(state, action.payload),
      )
      .addCase(createFinalized.fulfilled, (state, action) =>
        adapter.addOne(state, action.payload),
      )
      .addCase(accept.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(rectify.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(submit.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(cancel.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(REDUCER_KEY + '/removeAll', state => adapter.removeAll(state))
      .addMatcher(
        ({ type }) =>
          type.startsWith(REDUCER_KEY) && type.endsWith('fulfilled'),
        readyActionHandler,
      )
      .addMatcher(
        ({ type }) => type.startsWith(REDUCER_KEY) && type.endsWith('pending'),
        pendingActionHandler,
      )
      .addMatcher(
        ({ type }) => type.startsWith(REDUCER_KEY) && type.endsWith('rejected'),
        rejectActionHandler,
      );
  },
});

export const { reducer } = slice;
